import { SignUpPage } from '@features/onboarding/components/login/SignUpPage';
import { InvitationSearchSchema } from '@routes/searchSchemas';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/signup')({ validateSearch: InvitationSearchSchema, component: SignUpPage });
